"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarSectionItemContainer = exports.default = void 0;
const react_1 = __importStar(require("react"));
const react_lazy_load_1 = __importDefault(require("react-lazy-load"));
const sidebar_section_item_component_1 = require("./sidebar-section-item.component");
const SidebarSectionItemContainer = ({ title, total, isUseLazyLoad = true, itemId, isCheckboxChecked, isBlockIconChecked, onCheckboxClick, onBlockIconClick, className, }) => {
    const handleCheckboxClick = (0, react_1.useCallback)((event) => {
        event.stopPropagation();
        return onCheckboxClick(itemId);
    }, [itemId, onCheckboxClick]);
    const handleBlockIconClick = (0, react_1.useCallback)((event) => {
        event.stopPropagation();
        return onBlockIconClick(itemId);
    }, [itemId, onBlockIconClick]);
    const generalProps = {
        title,
        total,
        className,
        itemId,
        isBlockIconChecked,
        isCheckboxChecked,
        handleCheckboxClick,
        handleBlockIconClick,
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, isUseLazyLoad ? (react_1.default.createElement(react_lazy_load_1.default, { offset: 100 }, react_1.default.createElement(sidebar_section_item_component_1.SidebarSectionItem, Object.assign({}, generalProps)))) : react_1.default.createElement(sidebar_section_item_component_1.SidebarSectionItem, Object.assign({}, generalProps))));
};
const MemoizedSidebarSectionItemContainer = react_1.default.memo(SidebarSectionItemContainer);
exports.default = MemoizedSidebarSectionItemContainer;
exports.SidebarSectionItemContainer = MemoizedSidebarSectionItemContainer;
